APPS.pledge.thankyoufull = (function(){

	var show = function(data){
		console.log('APPS.pledge.thankyoufull.show',data)
		APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))

		APP.getView().showChildView('mainRegion', new pageView({
			model:new Backbone.Model(data)
		}) )    
	}
    
    
    
    
    
	/***************************************
	    VIEWS 
	***************************************/
		// THE PAGE
		var pageView = Marionette.View.extend({
			 template:_.template($("#tmpl-pledge-full-thanks").html())
			,className:"page_pledge_full_thanks mt8 pb8"
			,templateContext:function(){
				var message = "";
				name = ((this.model.attributes.titleOther)?this.model.attributes.titleOther:this.model.attributes.title) + " " + this.model.attributes.fname + " " + this.model.attributes.mname + " " + this.model.attributes.lname;
				name2 = ((this.model.attributes.titleOther2)?this.model.attributes.titleOther2:this.model.attributes.title2) + " " + this.model.attributes.fname2 + " " + this.model.attributes.mname2 + " " + this.model.attributes.lname2;

				type = (this.model.attributes.type == "sustainer")? 'Sustainer (Monthly Ongoing)' : 'One-Time Pledge';
				if( this.model.attributes.type == 'installment'){
					type = 'Installments';
				}
				
				//figure out what to show for pledge amount since endowment changes things							  
				var amount = this.model.attributes.amount,
					amountText  = '', 
					endowAmount = 0,
					installmentAmount = 0;
					
				if(this.model.attributes.type == "sustainer"){ amountText += "/month"; }
				
				if(this.model.attributes.shippingfee == 'ENDOW5'){
					if(this.model.attributes.type == 'sustainer'){
						endowAmount = 1 
					}else if(this.model.attributes.type == 'installment'){
						//installments are quarterly or monthly. Endowment is $1 per installment.
						endowAmount = (this.model.attributes.term==="Q")? 4 : 12;
					}else{ //one-time pledge
						endowAmount = 5;
					}
					
					amountText += ' <span style="font-size:14px">(includes $'+endowAmount+' for Endowment)</span>';
				}
				amount = accounting.formatMoney(+amount+endowAmount);


				var paymentTypeFormatted = 'Credit Card';
				if(this.model.attributes.paymentType == "EFT"){ paymentTypeFormatted = 'Checking Account (EFT)'; }
				if(this.model.attributes.paymentType == "SendBill"){ paymentTypeFormatted = 'Check'; }
				//the looked up options
				if(this.model.attributes.paymentType == "CREDITCARD" && this.model.attributes.guid){ paymentTypeFormatted = 'Using Existing Credit Card'; }
				if(this.model.attributes.paymentType == "EFT" && this.model.attributes.guid){ paymentTypeFormatted = 'Using Existing Checking Account (EFT)'; }		



				var paymentDetailsText = "";
				if(this.model.attributes.paymentType == "CREDITCARD"){ 
					if(this.model.attributes.ccnum){
						var ccNum = Array(this.model.attributes.ccnum.length-4).join('*') + this.model.attributes.ccnum.slice(-4);
						paymentDetailsText = ccNum + " (" + this.model.attributes.ccmonth + "/" + this.model.attributes.ccyear + ")";
					}else{ //existing # from sustainer lookup
						var tmpDate = this.model.attributes.charge_expire_date.split("-");
						paymentDetailsText = "************"+this.model.attributes.cclastfour + " (" + tmpDate[1] + "/" + tmpDate[2] + ")";
					}
				}else if(this.model.attributes.paymentType=="EFT"){ 
					if(this.model.attributes.guid){ //existing # from sustainer lookup
						paymentDetailsText = 'Routing Number: '+this.model.attributes.bankid+"<br>Account Number: ********"+this.model.attributes.bankacct 	
					}else{
						paymentDetailsText = 'Routing Number: '+this.model.attributes.bankid+"<br>Account Number:"+this.model.attributes.bankacct 
					}
				}else{ //check
					paymentDetailsText = "You will receive an invoice reminder in the mail very soon.";
				}
				
				
				
				message = "<p>Your support of Public Broadcasting is what helps us continue to bring you the quality programming you've come to expect and rely on. You and your neighbors are the 'public' in Public Media.</p>";
				//Passport
				if(this.model.attributes.email && (+this.model.attributes.amount >= 60 || (+this.model.attributes.amount >=5 && this.model.attributes.type=="sustainer"))){
					message += "<h2 class='mt8 mb0'>Your WHRO Passport is ready.</h2>"
					message += "<div style='overflow:auto'><img src='/assets/imgs/passport_compass_rose.svg' class='mt1 mr4' style='width:4em;float:left' />"
					message += "<p>Your giving level qualifies you for WHRO Passport. This member benefit grants you access to an extended, on-demand library of quality television programming. If you're new to Passport, we'll be sending you a separate email that will walk you through the activation process. Or, you can <a href='https://passport.whro.org/faq' target='_blank'>browse our FAQ</a> if you'd like more information now.</p>";
					message += "</div>";
				}
				
				//Gift / Premium
				if(this.model.attributes.gift && this.model.attributes.gift!="NOGIFT"){
					message += "<h2 class='mt8 mb0'>We hope you enjoy your gift.</h2>";
					message += "<div style='overflow:auto'><img class='mr4' style='width:6em;float:left' src='/assets/img/gifts/"+this.model.attributes.gift+".jpg' />";
					message += "<p>"+this.model.attributes.giftTitle+"</p>"
					if(this.model.attributes.giftCategory==="Tickets"){ //PT #134614343 - treat all gifts the same regardless of pledge type -- except tickets, see the morass that is PT #151324424
						if(this.model.attributes.gift=="P20460"){ // PT #171282790 - Antique's Roadshow 2020
							message += "<p class='mb0'>ANTIQUES ROADSHOW tickets will be delivered electronically to the email address on file. You must have a ticket printout to enter the appraisal event.</p>";	
						}else{
							message += "<p class='mb0'>The tickets you requested, as a thank you, will be held at the box office, will-call window. Please bring a picture ID to confirm your reservation on the day of the event.</p>";
							message += "<p>This confirmation <strong class='font-bold'>cannot</strong> serve as an acceptable form of ID.</p>";
						}
						if(this.model.attributes.giftTicketLocation || this.model.attributes.giftTicketDate || this.model.attributes.giftTicketTime){
							message += "<h3 class='mb0'>Ticket Information</h3>";
							message += "<p>";
								if(this.model.attributes.giftTicketLocation){ message += "Location: "+this.model.attributes.giftTicketLocation+"<br>"; }
								if(this.model.attributes.giftTicketDate){ message += "Date: "+moment(this.model.attributes.giftTicketDate).format("MMMM Do, YYYY")+"<br>"; }
								// Salesforce passes the time through with Z on it, meaning it is UTC. But it is not UTC. 
								//	Using parseZone() tells moment to keep the zone, which in this case means displaying it as 'utc', which is actually Eastern
								if(this.model.attributes.giftTicketTime){ message += "Time: "+moment.parseZone(this.model.attributes.giftTicketDate+" "+this.model.attributes.giftTicketTime).format("hh:mm a"); }
							message += "</p>";
						}
					}else{
						message += "<p class='mb0'>Your gift of appreciation will be shipped within 6- 8 weeks.</p>";
					}
					//holiday message
					//message += "<p>Here at WHRO we strive to give each and every one of our donors the best in not just programing, but also customer service. We are trying our very hardest to get each gift delivered by the holidays. If your gift does not arrive before your big day please use the link below to print a certificate that you can give to your loved one with the knowledge that their gift is on its way. A printed certificate will also arrive along with your acknowledgement letter.</p><p><a href='/assets/img/HolidayVoucher2017.jpg' target='_blank'>Holiday Certificate (click to view)</a></p>";
					
					message += "</div>";
				}
				
				
				//Employer
				if(this.model.attributes.employerId){
					if(this.model.attributes.gift && this.model.attributes.gift!="NOGIFT"){
						message += "<h2 class='mt4 mb0'>Speaking of gifts...</h2>";
					}else{
						message += "<h2 class='mt8 mb0'>Employer Matching</h2>";
					}
					message += "<p>Your employer is part of a matching gift program.  Here is a link to <a href='https://members.whro.org/matchinggiftprofile.php?id="+this.model.attributes.employerId+"' target='_blank'>your company's matching gift page</a>. Simply complete their form (or fill out the online form if available) and return it to:<br/>WHRO, Attn: Membership, 5200 Hampton Boulevard, Norfolk, VA 23508<br/>We will take care of the rest!</p>";
				}
				
				//Help
				message += "<h2 class='mt8 mb0'>We're here if you need us.</h2>"
				message += "<p>If you have any questions, please contact us at (757) 889-9499 or email <a href='mailto:info@whro.org'>info@whro.org</a>.</p>";
				
				
				//Print button / Email
				message += "<p><button class='btn btn-xs font-bold mt4 mr4' onclick='window.print()'>PRINT</button>";
				if(this.model.attributes.email){
					message += "You will receive an email confirmation of your pledge shortly. In the meantime, we recommend you print this page for your records."
				}else{
					message += "Please print this page for your records."
				}
				message += "</p>"





				

				return{
					 message:message
					,name:name
					,name2:name2
					,type:type
					,amountFormatted: amount + amountText
					,paymentTypeFormatted:paymentTypeFormatted
					,paymentDetailsText:paymentDetailsText
					,giftTitle: (this.model.attributes.giftTitle!="")?this.model.attributes.giftTitle:"No Gift - Apply entire donation towards programming"
				}
			}
		})


    return {
        show:show
    }
})();